document.addEventListener("DOMContentLoaded", function () {
  // if (window.innerWidth < 990) return;
  // const isHome =
  //   location.pathname === "/" ||
  //   location.pathname === "/index.html";

  // if (!isHome && sessionStorage.getItem("site_loader_played")) return;
  // if (!isHome) return;
  if (typeof gsap === "undefined") return;
  let animationDone = false;
  let pageLoaded = false; // already loaded
  const loader   = document.getElementById("site-loader");
  const logo     = document.getElementById("loader-logo");
  const dot      = document.getElementById("loader-dot");
  const frame    = document.getElementById("loader-frame");
  const wordmark = document.getElementById("loader-wordmark");

  if (!loader || !logo || !dot || !frame || !wordmark) return;
  const desktopInner = loader.querySelector(".loader-inner.loader-inner-desktop");

  if (desktopInner) {
    desktopInner.style.display = "flex";
  }
  /* =====================================
     LOCK SITE
  ===================================== */
  document.documentElement.classList.add("loader-lock");

  gsap.set(loader, {
    visibility: "visible",
    opacity: 1
  });

  /* =====================================
     INITIAL STATES
  ===================================== */
  gsap.set(logo, {
    opacity: 1,
    scale: 1,
    transformOrigin: "50% 50%"
  });

  gsap.set(dot, { opacity: 0, scale: 0 });
  gsap.set(frame, { opacity: 0, scale: 0.6 });
  gsap.set(wordmark, { opacity: 0, y: 12 });

  /* =====================================
     MAIN LOADER ANIMATION
  ===================================== */
  const tl = gsap.timeline({ defaults: { ease: "power2.out" } });

  tl.to(dot, {
      opacity: 1,
      scale: 1,
      duration: 0.5
    })
    .to(dot, {
      scale: 1.15,
      duration: 0.3,
      yoyo: true,
      repeat: 1
    }, "-=0.1")
    .to(frame, {
      opacity: 1,
      scale: 1,
      duration: 0.5
    }, "-=0.1")
    .to(wordmark, {
      opacity: 1,
      y: 0,
      duration: 0.5
    })
    .to(logo, {
      scale: 1.02,
      duration: 0.4,
      yoyo: true,
      repeat: 1
    });

  // let animationDone = false;
  // let pageLoaded = false;

  tl.eventCallback("onComplete", () => {
    animationDone = true;
    // if (!isHome) sessionStorage.setItem("site_loader_played", "true");
    tryHideLoader();
  });

  window.addEventListener("load", () => {
    pageLoaded = true;
    tryHideLoader();
  });
  function tryHideLoader() {
    if (!animationDone || !pageLoaded) return;

    const headerLogo = document.querySelector(".header__heading-logo");
    if (!headerLogo) return;

    /* Lock transform origin (your 21% requirement) */
    gsap.set(logo, {
      transformOrigin: "50% 22%"
    });

    /* Measure positions */
    const headerRect = headerLogo.getBoundingClientRect();
    const logoRect   = logo.getBoundingClientRect();

    /* Exact movement */
    const deltaX =
      headerRect.left +
      headerRect.width / 2 -
      (logoRect.left + logoRect.width / 2);

    const deltaY =
      headerRect.top +
      headerRect.height / 2 -
      (logoRect.top + logoRect.height * 0.21);

    /* =====================================
       🔥 SCALE FIX (NO SMALL LOGO)
    ===================================== */
    const svgBBox = logo.getBBox();
    const SVG_DRAWN_WIDTH = svgBBox.width;
    const CURRENT_WIDTH   = logoRect.width;
    const TARGET_WIDTH    = headerRect.width;
    console.log(TARGET_WIDTH)
    const correctionFactor = CURRENT_WIDTH / SVG_DRAWN_WIDTH;

    const scale =
      (TARGET_WIDTH / CURRENT_WIDTH) / correctionFactor * 4.20;

    /* EXIT TIMELINE */
    const exitTl = gsap.timeline({ defaults: { ease: "power2.out" } });

    exitTl
      // Hide wordmark
      .to(wordmark, {
        opacity: 0,
        duration: 0.25
      })

      // Move + scale logo
      .to(logo, {
        x: deltaX,
        y: deltaY,
        scale: scale,
        duration: 0.7
      })

      // Reveal site AFTER logo lands
      .add(() => {
        loader.classList.add("loader-overlay--transparent");
        document.documentElement.classList.remove("loader-lock");
      })

      // Small buffer (important)
      .to({}, { duration: 0.05 })

      // Swap logos (no fade, no jump)
      .add(() => {
        logo.style.opacity = "0";
        headerLogo.style.opacity = "1";
      })

      // Remove overlay
      // .to(loader, {
      //   opacity: 0,
      //   duration: 0.35,
      //   onComplete() {
      //     loader.classList.add("is-hidden");
      //   }
      // });
      .to(loader, {
        opacity: 0,
        duration: 0.35,
        onStart() {
          document.documentElement.classList.remove("loader-lock");
        },
        onComplete() {
          loader.classList.add("is-hidden");
        }
      });
  }
});

// document.addEventListener("DOMContentLoaded", () => {
window.addEventListener("load", function () {
  if (window.innerWidth >= 990) return;
    // const isHome =
    // location.pathname === "/" ||
    // location.pathname === "/index.html";

  // if (!isHome && sessionStorage.getItem("site_loader_played")) return;
  // if (!isHome) return;
  if (typeof gsap === "undefined") return;

  const loader = document.getElementById("site-loader");
  const wrap   = document.getElementById("mobile-logo-wrap");
  const frame  = document.getElementById("mobile-logo-frame");
  const symbol = wrap.querySelector(".loader-symbol");
  const text   = document.getElementById("mobile-loader-text");
  const header = document.querySelector(".header_main_logo_wrapper");

  if (!loader || !wrap || !symbol || !frame || !text || !header) return;
  const monileInner = loader.querySelector(".loader-inner.loader-inner-mobile");

  if (monileInner) {
    monileInner.style.display = "flex";
  }
  /* =====================================================
     LOCK PAGE + SHOW LOADER
  ===================================================== */
  gsap.set(loader, { visibility: "visible", opacity: 1 });
  document.documentElement.classList.add("loader-lock");

  /* =====================================================
     INITIAL STATES
  ===================================================== */
  gsap.set(wrap, {
    x: 0,
    y: 0,
    scale: 1,
    transformOrigin: "50% 50%"
  });

  gsap.set(frame, {
    opacity: 0,
    scale: 0.6,
    transformOrigin: "50% 50%"
  });

  gsap.set(symbol, {
    scale: 1,
    x: 0,
    transformOrigin: "50% 50%"
  });

  gsap.set(text, {
    display: "none",
    opacity: 0,
    x: 40
  });

  /* =====================================================
     TIMELINE
  ===================================================== */
  const tl = gsap.timeline({ defaults: { ease: "power3.out" } });

  /* STEP 1 — LOGO FROM BOTTOM TO CENTER */
  tl.to(wrap, {
    y: "-50vh",
    scale: 2,
    duration: 1
  });

  /* STEP 2 — FRAME APPEAR */
  tl.to(frame, {
    opacity: 1,
    scale: 1,
    duration: 0.45
  }, "-=0.2");

  /* STEP 3 — MOVE LEFT TO HEADER */
  tl.to(wrap, {
    xPercent: -1,
    x: () => {
      const symbolRect = symbol.getBoundingClientRect();
      const headerRect = header.getBoundingClientRect();

      const symbolCenterX =
        symbolRect.left + symbolRect.width / 2;

      const headerCenterX =
        headerRect.left + headerRect.width / 2;

      return headerCenterX - symbolCenterX;
    },
    scale: 1,
    duration: 0.45,
    ease: "power3.inOut"
  });

  /* STEP 4 — SWITCH TO FLEX (NO ANIMATION) */
  tl.set(".mobile-logo-inner", {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    x: -20
  });

  /* STEP 5 — TEXT SLIDE IN FROM RIGHT */
  tl.to(text, {
    display: "block",
    opacity: 1,
    x: 0,
    duration: 0.45
  });

  /* STEP 6 — RECALCULATE & LOCK SYMBOL TO HEADER */
tl.add(() => {
  const symbolRect = symbol.getBoundingClientRect();
  const headerRect = header.getBoundingClientRect();

  const symbolCenterX = symbolRect.left + symbolRect.width / 2;
  const symbolCenterY = symbolRect.top + symbolRect.height / 2;

  const headerCenterX = headerRect.left + headerRect.width / 2;
  const headerCenterY = headerRect.top + headerRect.height / 2;

  const moveX = headerCenterX - symbolCenterX;
  const moveY = headerCenterY - symbolCenterY;

  // 🔥 scale ratio (match header logo size)
  const scaleX = headerRect.width / symbolRect.width;
  const scaleY = headerRect.height / symbolRect.height;
  const finalScale = Math.min(scaleX, scaleY); // keep aspect ratio

  let textHidden = false;

  gsap.to([symbol, text], {
    x: `+=${moveX}`,
    y: `+=${moveY}`,
    scale: finalScale,
    transformOrigin: "50% 50%",
    duration: 1,
    ease: "power3.inOut",

    onUpdate() {
      if (!textHidden && this.progress() >= 0.5) {
        textHidden = true;

        gsap.to(text, {
          opacity: 0,
          duration: 0.25,
          ease: "power2.out"
        });
      }
    }
  });
});


/* STEP 7 — SCROLL UP HALF SCREEN + HIDE TEXT */

// tl.to(window, {
//   scrollTo: { y: window.innerHeight / 2 },
//   duration: 0.45,
//   ease: "power2.out"
// }, "<");

  /* STEP 8 — REMOVE LOADER */
  tl.add(() => {
      // sessionStorage.setItem("site_loader_played", "true");
    // gsap.delayedCall(2, () => {
    gsap.delayedCall(0.7, () => {
      gsap.to(loader, {
        opacity: 0,
        // duration: 0.4,
        duration: 0,
        ease: "power2.out",
        onComplete: () => {
          loader.style.display = "none";
          document.documentElement.classList.remove("loader-lock");
        }
      });
    });
  });
});